interface Props {
  className?: string;
}
const SortDescendingIcon: (props: Props) => JSX.Element = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M19.5 13.5L12 21M12 21L4.5 13.5M12 21V3"
        stroke="#1E40AF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SortDescendingIcon;
